export const AGENTS_DASHBOARD_BASE_URL = import.meta.env.DEV
  ? "http://localhost:3002"
  : "http://agents-dashboard-aws-us-east-1.fox-diatonic.ts.net";
